
















































































































// import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import  { MswApiService } from '@/shared/msw-api-service';
// import { MSSPDetails, MsspGoverningList } from '@/modules/msw-tenant-management/types';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { ApiError } from '@sonicwall/unified-ui-framework/src/shared/api-service';
import { InfoState } from '@/core/core.store';
import { TooltipDirValues } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import { UserGroupList, UserModalType } from './types';
import { UserGroup, UserGroupReponse, MSSPPrefilterResponseType } from './userGroupTypes';
import { SwActionBar, SwActionBarItem } from '@sonicwall/unified-ui-framework/src/shared/sw-action-bar';
import RegexValidators from '../../../shared/regex-validators';
import { currentUserKey } from '@/shared/msw-constants';
const cssPrefix = 'user-modal';

@Component({
  components: {
    ...UUIFComponents,
    SwActionBar,
    SwActionBarItem,
  },
})

export default class UserModal  extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ required: true , type : Boolean , default : false })
  showModal: boolean;

  @Prop({ required: true , type : String , default : 'add' })
  modalType: 'add' | 'edit';

  @Prop({ required: false , type : Object })
  modalData: UserModalType;

  @Prop({ required: false , type : String })
  msspName: string;

  @Prop({ required: false , type : String })
  userGroupName: string;

  @Prop({ required: false , type : String, default: 'FALSE' })
  isDefaultUserGroup: string;

  @Prop({ default: {
    content: {
      MSSPs: [],
      Products: [],
      ProvisionMSSP: '',
      ProvisionTenant: '',
      ProvisionProduct: '',
      ProvisionTenantMsg: '',
      ProvisionProductMsg: '',
    },
    operationStatus: '',
    msgCode: '',
    msgId: '',
    msgDesc: '',
  }})
  msspPrefilterResponse: MSSPPrefilterResponseType;

  modalTitle = String(this.$t('accessMgmt.iUser'));
  msspDropDownVal: SelectOption[] = [];
  contactTypeDropDownVal: SelectOption[] = [];
  userGrpDropDownOptions: SelectOption[] = [];
  defaultValuesModalData: UserModalType = {
    selectedMssp: '',
    selectedContactType: '',
    selectedUserGrp: '',
    emailAddress: '',
    firstName: '',
    lastName: '',
    userGroup: [],
  };
  userModalFields = this.defaultValuesModalData;
  showErrorMsg = false;
  inValidEmail: boolean = false;
  userGrpDataFromApi: UserGroupReponse['userGroups'] = [];
  showMssp: boolean = false;

  get contactTypeTooltip(): TooltipDirValues {
    let content = '';
    content = String(this.$t('userGroups.contentTypeTooltipMssp'));
    return {
      content,
      placement: 'top',
      compact: true,
      maxWidth: 275,
      includePopperForHover: true,
      doAnimation: true,
    };
  }

  get getWidth() {
    const width: any = '58rem';
    return width;
  }

  onCloseModal() {
    this.$emit('closeUserModal', true);
  }

  getListOfMssp() {
    return new Promise((res) => {
      MswApiService.usageReport.getMsspList()
      .then((resp: MSSPPrefilterResponseType) => {
        const msspOptions: SelectOption[] = [];
        this.showMssp = resp.content.ProvisionMSSP === 'YES' ? true : false;
        if (resp.content && resp.content.MSSPs) {
          resp.content.MSSPs.map((ele: any) => {
            if (ele.MSSPStatus === 'ACTIVE') {
              msspOptions.push({
                id: ele.MSSPID.toString() || '',
                value: ele.MSSPName || '',
                label: ele.MSSPName || '',
              });
            }
          });
          this.msspDropDownVal = msspOptions;
        }
        res(true);
      })
      .catch((error: ApiError) => {
        const message: InfoState = { infoType: 'high', infoMsg: error.message || String(this.$t('accessMgmt.unknown')) };
        this.$store.commit('displayMessage', message);
        res(true);
      });
    });
  }
  getContactTypeList() {
    return new Promise((res) => {
      // API for contact type here
      this.contactTypeDropDownVal = [
        { id: '10001', label: String(this.$t('accessMgmt.employee')), value : 'employee' },
      ];
      this.userGrpDataFromApi.forEach((ele: any) => {
        if (ele.isDefaultGroup !== 'TRUE' && (ele.partyGroupId === this.userModalFields.selectedUserGrp)) {
          this.contactTypeDropDownVal.push({ id: 'Partner', label: String(this.$t('accessMgmt.partner')), value : 'partner' });
          this.contactTypeDropDownVal.push({ id: '10015', label: String(this.$t('accessMgmt.customer')), value : 'customer' });
        }
      });
      // if (this.isDefaultUserGroup !== 'TRUE') {
      //   this.contactTypeDropDownVal.push({ id: 'Partner', label: String(this.$t('accessMgmt.partner')), value : 'partner' });
      //   this.contactTypeDropDownVal.push({ id: '10015', label: String(this.$t('accessMgmt.customer')), value : 'customer' });
      // }
      res(true);
    });
  }
  formatModalData() {
    return new Promise((res) => {
      const propData = this.modalData ? this.modalData : this.defaultValuesModalData;
      this.userModalFields = {
        firstName: propData.firstName,
        lastName: propData.lastName,
        emailAddress: propData.emailAddress,
        selectedContactType: propData.selectedContactType,
        selectedMssp: propData.selectedMssp?.toString(),
        userGroup: propData.userGroup,
        selectedUserGrp: propData.selectedUserGrp,
      };
      this.userGrpDropDownOptions = [...this.formatUserGrpToSelectList(propData.userGroup)];
      res(true);
    });
  }

  formatUserGrpToSelectList(userGroupArray: UserGroupList[]): SelectOption[] {
    const userGrpDropDown: SelectOption[] = userGroupArray.map((userGroupVal: UserGroupList) => {
      return {
        id : userGroupVal.userGroupName,
        label: userGroupVal.userGroupName,
        value: userGroupVal.usergroupId,
      };
    });
    return userGrpDropDown;
  }

  formatUserGroups() {
    const usergrpDropDown: SelectOption[] = [];
    this.userGrpDataFromApi.forEach((userGrp: UserGroup) => {
      if (userGrp.MSSPID === this.userModalFields.selectedMssp) {
        usergrpDropDown.push({
          id: userGrp.partyGroupId,
          value: userGrp.partyGroupName,
          label: userGrp.partyGroupName,
        });
      }
    });
    return usergrpDropDown;
  }

  loadUserGroupData() {
    return new Promise((res: any) => {
      const dataToBePosted = {
        isForced: 'true',
        mode: '',
        masterMSSPID: this.userModalFields.selectedMssp,
        isfromMSSPPage: 'YES',
        skipUsers: 'NO',
      };
      // MswApiService.userGroup.getUserGroupList()
      MswApiService.userGroup.getUserGroupListForMsspId(dataToBePosted)
      .then((resp: UserGroupReponse) => {
        this.userGrpDataFromApi = resp.userGroups || [];
        this.userGrpDropDownOptions = [...this.formatUserGroups()];
        this.onChangeUserGroup();
        res(true);
      })
      .catch((error: ApiError) => {
        const message: InfoState = { infoType: 'high', infoMsg: error.message || String(this.$t('accessMgmt.unknown')) };
        this.$store.commit('displayMessage', message);
        res(true);
      });
    });
  }
  onClickCancel() {
    this.userModalFields = this.defaultValuesModalData;
    this.$emit('closeUserModal', false);
  }

  checkEmail() {
    const regexStr =  new RegExp(RegexValidators.email);
    this.inValidEmail = !regexStr.test(this.userModalFields.emailAddress);
  }

  get getValidationFlag() {
    let flag = false;
    flag = (this.userModalFields.selectedMssp !== '') && (this.userModalFields.selectedContactType !== '') && (this.userModalFields.selectedUserGrp !== '') && (this.userModalFields.emailAddress !== '');
    return flag;
  }

  onClickInvite() {
    this.showErrorMsg = true;
    if (this.getValidationFlag) {
      this.$store.commit('startLoading');
      const data = {
        masterMsspId: this.userModalFields.selectedMssp,
        contactTypeId: this.userModalFields.selectedContactType,
        partyGroupId : this.userModalFields.selectedUserGrp,
        emailAddress : this.userModalFields.emailAddress,
        firstName : this.userModalFields.firstName,
        lastName : this.userModalFields.lastName,
      };
      MswApiService.createCustomer.addUsers(data, true)
      .then((resp: any) =>  {
        if (resp.msgCode === 'MSWAPP:ADDUSERWARNING') {
          this.$store.commit('stopLoading');
          // this.confirmAdd(data, resp.msgDesc);
        } else if (resp.operationStatus === 'NOK') {
          this.$store.commit('stopLoading');
          const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
          this.$store.commit('enqueueMessage', message);
        } else if (resp.msgCode === 'MSWAPP:ADDUSERSUCCESS') {
          this.$store.commit('stopLoading');
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('enqueueMessage', message);
          this.$emit('closeUserModal', true);
        }
        this.$store.commit('stopLoading');
      });
    }
    // post data here and then emit
  }

  onClickSave() {
    this.showErrorMsg = true;
    // edit data here and then emit
    this.$emit('closeUserModal', true);
  }

  async intialisePage() {
    try {
      const selectedMssp = this.$store.getters['AccessManagementStoreModule/getSelectedMssp'];
      this.userModalFields.selectedMssp = selectedMssp.id !== undefined ? selectedMssp.id : selectedMssp;
      this.userModalFields.selectedUserGrp = this.userGroupName !== undefined ? this.userGroupName : '';
      this.$store.commit('startLoading');
      await this.getListOfMssp();
      await this.getContactTypeList();
      if (this.modalType === 'edit') {
        await this.formatModalData();
      }
      if (this.modalType === 'add') {
        await this.loadUserGroupData();
      }
      this.$store.commit('stopLoading');
    } catch {
      this.$store.commit('stopLoading');
    }
  }

  mounted() {
    this.modalTitle = this.modalType === 'add' ? String(this.$t('accessMgmt.iUser')) : String(this.$t('accessMgmt.editUser'));
    this.intialisePage();
    console.warn('changes added for localisation');
  }

  checkForMasterMsspRole() {
    const tempObj: any = localStorage.getItem(currentUserKey);
    const userInfoObtained: any = JSON.parse(tempObj);
    if (userInfoObtained.roles && userInfoObtained.roles.includes('MASTERMSSP')) {
      return true;
    }
    return false;
  }

  async onChangeMssp() {
    this.userModalFields.selectedUserGrp = '';
    try {
      this.$store.commit('startLoading');
      await this.loadUserGroupData();
      // this.onChangeUserGroup();
      this.$store.commit('stopLoading');
    } catch {
      this.$store.commit('stopLoading');
    }
  }

  fetchSelectedMsspDetails(id: string) {
    let msspDetails = {
      MSSPName: '',
      MSSPID: 0,
      Tenants: [],
      isGlobal: '',
    };
    if (this.msspPrefilterResponse.content) {
      this.msspPrefilterResponse.content.MSSPs.map((ele: any) => {
        if (ele.MSSPID.toString() === id) {
          msspDetails = Object.assign({}, {
            MSSPName: ele.MSSPName,
            MSSPID: ele.MSSPID,
            Tenants: ele.Tenants || [],
            isGlobal: ele.isGlobal,
          });
        }
      });
    }
    return msspDetails;
  }

  onChangeUserGroup() {
    console.warn(this.userGrpDataFromApi);
    this.userGrpDropDownOptions = [...this.formatUserGroups()];
    const msspSelected = this.userModalFields.selectedMssp ? this.userModalFields.selectedMssp : '';
    if (this.checkForMasterMsspRole() && (this.fetchSelectedMsspDetails(msspSelected).isGlobal === 'YES')) {
      if (this.userModalFields.selectedContactType !== '10001') {
        this.userModalFields.selectedContactType = '';
      }
      this.contactTypeDropDownVal = [
        { id: '10001', label: String(this.$t('accessMgmt.employee')), value : 'employee' },
      ];
      this.userGrpDataFromApi.forEach((ele: any) => {
        if (ele.isDefaultGroup !== 'TRUE' && (ele.partyGroupId === this.userModalFields.selectedUserGrp)) {
          this.contactTypeDropDownVal.push({ id: 'Partner', label: String(this.$t('accessMgmt.partner')), value : 'partner' });
          this.contactTypeDropDownVal.push({ id: '10015', label: String(this.$t('accessMgmt.customer')), value : 'customer' });
        }
      });
    } else {
      this.getContactTypeList();
    }
  }

}
